import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestOpeningComponent } from './request-opening.component';

@NgModule({
	declarations: [],
	imports: [RequestOpeningComponent],
	exports: [RequestOpeningComponent],
})
export class RequestOpeningModule {}
